import { render } from "./Battletrip.vue?vue&type=template&id=5af6d37e&scoped=true"
import script from "./Battletrip.vue?vue&type=script&lang=js"
export * from "./Battletrip.vue?vue&type=script&lang=js"

import "./Battletrip.vue?vue&type=style&index=0&id=5af6d37e&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af6d37e"]])

export default __exports__